import React from 'react';
import clsx from 'clsx';

interface BadgeProps {
    maritime?: boolean;
    news?: boolean;
    ATC?: boolean;
    insights?: boolean;
    coastal?: boolean;
    energy?: boolean;
    customBadge?: string[]; // Change to array of strings for multiple custom badges
    className?: string;
    children?: React.ReactNode; // Optional children
    key?: number;
}

export default function Badge({
    news,
    insights,
    customBadge,
    className,
    children,
}: BadgeProps) {
    // Define predefined badges
    const predefinedBadges = [
        { key: 'news', label: 'News', visible: news },
        { key: 'insights', label: 'Insights', visible: insights },
    ];

    return (
        <div className={clsx(className, 'badge__wrapper')}>
            {/* Render predefined badges */}
            {predefinedBadges && predefinedBadges.map(({ key, label, visible }) =>
                visible ? (
                    <span key={key} className={clsx(className, `badge badge__${key}`)}>
                        {label}
                    </span>
                ) : null
            )}
            {/* Render custom badges if provided */}
            {customBadge && customBadge.map((badge, index) => (
                <span key={`custom-badge-${index}`} className={clsx(className, 'badge badge--topic')}>
                    {badge}
                </span>
            ))}

        </div>
    );
}
